import axios from 'axios';

const store = {};
export default class ItemCourse {
  constructor() {

  }

  getAgency(currency, secondCurrency, date = (new Date()).toStringRu()) {
    // console.log(currency, secondCurrency, date);
    return new Promise((resolve, reject) => {
      if (!currency || !secondCurrency) reject();
      ItemCourse
        .getAgency(currency, secondCurrency, date)
        .then(resolve, reject)
    });
  }

  getOperator(currency, secondCurrency, operator, date = (new Date()).toStringRu()) {
    return new Promise((resolve, reject) => {
      if (!currency || !secondCurrency || !operator) reject();
      ItemCourse
        .getOperator(currency, secondCurrency, operator, date)
        .then(resolve, reject)
    });
  }

  static getAgency(currency, secondCurrency, date) {
    return new Promise((resolve, reject) => {
      if (currency === secondCurrency) resolve(1);
      let name = `${currency}/${secondCurrency}/${date}`;
      if (!store[name]) {
        store[name] = {
          data: null,
          resolve: [],
          reject: [],
        }
      }
      if (store[name].data) return resolve(store[name].data);
      store[name].resolve.push(resolve);
      store[name].reject.push(reject);
      if (store[name].resolve.length > 1) return;
      if (currency === secondCurrency) {
        store[name].data = 1;
        store[name].resolve.forEach(i => i(1));
        return;
      }
      axios
        .get(`/tourclient/currencyRates?currencyId=${currency}&secondCurrencyId=${secondCurrency}&date.Serialized=${date}&_=${new Date().getTime()}`)
        .then(({ data }) => {
          store[name].data = data.Value ? data.Value : 1;
          if (data.ResultQueryInfo.UserMessages) {
            store[name].resolve.forEach(i => i(1));
          } else {
            store[name].resolve.forEach(i => i(data.Value));
          }
        }, () => {
          store[name].reject.forEach(i => i('Не удалось получить данные с сервера'));
        })
        .finally(() => {
          store[name].resolve = [];
          store[name].reject = [];
        })
    });
  }

  static getOperator(currency, secondCurrency, operator, date) {
    return new Promise((resolve, reject) => {
      if (currency === secondCurrency) resolve(1);
      let name = `${currency}/${secondCurrency}/${operator}/${date}`;
      if (!store[name]) {
        store[name] = {
          data: null,
          resolve: [],
          reject: [],
        }
      }
      if (store[name].data) return resolve(store[name].data);
      store[name].resolve.push(resolve);
      store[name].reject.push(reject);
      if (store[name].resolve.length > 1) return;
      if (currency === secondCurrency) {
        store[name].data = 1;
        store[name].resolve.forEach(i => i(1));
        return;
      }
      axios
        .get(`/tourclient/currencyRates?currencyId=${currency}&secondCurrencyId=${secondCurrency}&operatorId=${operator}&ignoreOperatorOrAgencySetting=true&date.Serialized=${date}&_=${new Date().getTime()}`)
        .then(({ data }) => {
          store[name].data = data.Value ? data.Value : 1;
          if (data.ResultQueryInfo.UserMessages) {
            store[name].resolve.forEach(i => i(1));
          } else {
            store[name].resolve.forEach(i => i(data.Value));
          }
        }, () => {
          store[name].reject.forEach(i => i('Не удалось получить данные с сервера'));
        })
        .finally(() => {
          store[name].resolve = [];
          store[name].reject = [];
        })
    });
  }
}
